// extracted by mini-css-extract-plugin
export default {"richTextEditor":"TypeTextareaRich_richTextEditor__FAGUP"};